import React, { useEffect, useState } from "react";
import { retrieveData } from "../LocalConnection/LocalConnection";
import {
  array_data_base,
  CustomerOrder,
  CustomerOrderDetail,
  initIndexedDB,
  openIndexDB,
} from "../LocalConnection/OfflineConnection";
import { StoreDataintoIndexDB } from "../LocalConnection/OfflineConnectionNew";
import { handleCallClick, handleError, handleLinkClick } from "../CommonJquery/CommonJquery";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

const ThankYou = () => {
  const navigate = useNavigate();
  const [db, setDb] = useState(null);
  const last_order_id = retrieveData("last_order_id");
  const last_database_name = retrieveData("last_database_name");
  const encrypted_restaurant_id = retrieveData("encrypted_restaurant_id");
  const encrypted_table_id = retrieveData("encrypted_table_id");
  useEffect(() => {
    const setDbCallback = async (result) => {
      const params = new URLSearchParams(window.location.search);
      const txnId = params.get("transactionId");
      setDb(result);
      master_data_get(result, txnId);
    };

    // Call the initIndexedDB function and pass the callback
    initIndexedDB(setDbCallback);
  }, []);

  const master_data_get = async (result, transactionId) => {
    try {
      if (result == null) {
        result = await openIndexDB();
      }
      const transaction_call = result.transaction(array_data_base, "readwrite");

      StoreDataintoIndexDB(transaction_call, CustomerOrderDetail, [], {
        flag: "0",
        clear_or_not: "clear",
      });
      StoreDataintoIndexDB(transaction_call, CustomerOrder, [], {
        flag: "0",
        clear_or_not: "clear",
      });
      const timer = setTimeout(() => {
        handleLinkClick(
          "/qr_menu/" + encrypted_restaurant_id + "/" + encrypted_table_id
        ); // redirect to homepage after 5 seconds
      }, 3000);
    } catch (error) {
      handleError(error);
      console.error("Error fetching data:", error);
    }
  };

  return (
    <>
    <Helmet>
    <title>Thank You</title>
  </Helmet>
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.heading}>🎉 Thank You!</h1>
        <p style={styles.text}>Your payment was successful.</p>
        <p style={styles.subtext}>
          We appreciate your business and hope to serve you again soon!
        </p>
      </div>
    </div>
    </>
  );
};

const styles = {
  container: {
    height: "100vh",
    backgroundColor: "#f2f4f8",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    backgroundColor: "#ffffff",
    padding: "40px",
    borderRadius: "16px",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    maxWidth: "400px",
  },
  heading: {
    marginBottom: "20px",
    color: "#2c3e50",
  },
  text: {
    fontSize: "18px",
    color: "#34495e",
  },
  subtext: {
    marginTop: "10px",
    fontSize: "14px",
    color: "#7f8c8d",
  },
};

export default ThankYou;
